

import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  FiSearch,
  FiHeart,
  FiShoppingCart,
  FiUser,
  FiMoreVertical,
} from "react-icons/fi";
import { FaTimes } from "react-icons/fa";

import SearchModal from "./SearchModal";
import BASE_URL from "../BASEURL";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  const backendUrl = BASE_URL;

  // AUTH
  useEffect(() => {
    const loadAuth = () => {
      setUser(JSON.parse(localStorage.getItem("currentUser")));
      setIsAdmin(localStorage.getItem("isAdmin") === "true");
    };

    loadAuth();
    window.addEventListener("authChanged", loadAuth);
    return () => window.removeEventListener("authChanged", loadAuth);
  }, []);

  // 🔥 GET USER-SPECIFIC CART KEY
  const getCartKey = (userData) => {
    if (userData?.email) {
      return `cartItems_${userData.email}`;
    }
    return "cartItems_guest";
  };

  // CART
  useEffect(() => {
    const update = () => {
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      const cartKey = getCartKey(currentUser);
      const cart = JSON.parse(localStorage.getItem(cartKey)) || [];
      setCartCount(cart.reduce((a, b) => a + Number(b.quantity || 0), 0));
    };

    update();
    window.addEventListener("cartUpdated", update);
    return () => window.removeEventListener("cartUpdated", update);
  }, [user]);

  // SCROLL LOCK
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const navLinkClass = ({ isActive }) =>
    isActive
      ? "font-semibold text-black border-b-2 border-black pb-1"
      : "text-black";

  return (
    <>
      {/* TOP NAVBAR */}
      <nav className="fixed top-0 left-0 w-full bg-white shadow-md z-[999]">
        <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">

          {/* LOGO */}
          <NavLink to="/">
            <img
              src="/image/logo/BG-LOGO.png"
              alt="logo"
              className="h-16 w-[180px] md:h-16 md:w-[180] object-cover"
            />
          </NavLink>

          {/* DESKTOP MENU */}
          <ul className="hidden md:flex gap-8">
            <li><NavLink to="/" className={navLinkClass}>Home</NavLink></li>
            <li><NavLink to="/about" className={navLinkClass}>About</NavLink></li>
            <li><NavLink to="/shop" className={navLinkClass}>Category</NavLink></li>
          </ul>

          {/* DESKTOP ICONS */}
          <div className="hidden md:flex items-center gap-5">
            <button onClick={() => setOpenSearch(true)}>
              <FiSearch size={22} />
            </button>

            <NavLink to="/wishlist">
              <FiHeart size={22} />
            </NavLink>

            <NavLink to="/cart" className="relative">
              <FiShoppingCart size={22} />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-black text-white text-[10px] px-1 rounded-full">
                  {cartCount}
                </span>
              )}
            </NavLink>

            
          </div>

          {/* MOBILE 3 DOT BUTTON */}
          <button
            className="md:hidden text-2xl"
            onClick={() => setMenuOpen(true)}
          >
            <FiMoreVertical />
          </button>
        </div>
      </nav>

      <div className="h-[70px]" />

      {/* BACKDROP */}
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-[9998]"
          onClick={() => setMenuOpen(false)}
        />
      )}

      {/* MOBILE MENU */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white z-[9999] transition-transform ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="font-semibold">Menu</h2>
          <FaTimes onClick={() => setMenuOpen(false)} />
        </div>

        <div className="p-4 flex flex-col gap-3">
          <NavLink onClick={() => setMenuOpen(false)} to="/" className="px-3 py-2 rounded bg-gray-100">
            Home
          </NavLink>

          <NavLink onClick={() => setMenuOpen(false)} to="/about" className="px-3 py-2 rounded bg-gray-100">
            About
          </NavLink>

          <NavLink onClick={() => setMenuOpen(false)} to="/shop" className="px-3 py-2 rounded bg-gray-100">
            Category
          </NavLink>

          

          {isAdmin && (
            <NavLink
              to="/admin"
              onClick={() => setMenuOpen(false)}
              className="px-3 py-2 rounded bg-red-500 text-white text-center"
            >
              Admin Panel
            </NavLink>
          )}
        </div>
      </div>

      {/* 🔥 MOBILE BOTTOM NAVBAR (FIXED & PERFECT) */}
      <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t shadow-xl z-[9999] flex justify-around items-center py-2">

        <NavLink to="/wishlist" className="flex flex-col items-center text-xs">
          <FiHeart size={20} />
          Wishlist
        </NavLink>

        <button
          onClick={() => setOpenSearch(true)}
          className="flex flex-col items-center text-xs"
        >
          <FiSearch size={20} />
          Search
        </button>

        <NavLink to="/cart" className="relative flex flex-col items-center text-xs">
          <FiShoppingCart size={20} />
          Cart
          {cartCount > 0 && (
            <span className="absolute -top-1 right-2 bg-black text-white text-[9px] px-1 rounded-full">
              {cartCount}
            </span>
          )}
        </NavLink>

        
      </div>

      {/* SEARCH MODAL */}
      {openSearch && <SearchModal onClose={() => setOpenSearch(false)} />}
    </>
  );
}